import Image from "next/image";
import { cn } from "@/lib/utils";

const DEFAULT_WIDTH = 48;
const DEFAULT_HEIGHT = 32;

interface ISiteLogoProps {
  /** Optional class for the wrapper (controls size when using h-* w-auto etc.). */
  className?: string;
  /** Width in pixels (used when no fill). */
  width?: number;
  /** Height in pixels (used when no fill). */
  height?: number;
  /** When true, logo fills the container (use with a sized wrapper and className). */
  fill?: boolean;
  /** Required for `fill` images so Next can generate the right `srcset`. */
  sizes?: string;
}

/**
 * Site logo used in header, footer, auth, and sidebar.
 * Renders the main logo SVG with consistent alt text and optional sizing.
 */
export function SiteLogo({
  className,
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
  fill = false,
  sizes = `${DEFAULT_WIDTH}px`,
}: ISiteLogoProps): React.ReactElement {
  if (fill) {
    return (
      <span className={cn("relative block", className)}>
        <Image
          src="/logos/logo.png"
          alt="Tippo"
          fill
          sizes={sizes}
          className="object-contain object-left"
          priority
        />
      </span>
    );
  }
  return (
    <Image
      src="/logos/logo.png"
      alt="Tippo"
      width={width}
      height={height}
      className={cn("object-contain", className)}
      style={{ width: "auto", height: "auto" }}
      priority
    />
  );
}
